<template>
  <div
    class="product-pricing flex"
    :class="{
      'flex-col gap-0': isVerticalPrice,
      'flex-col-reverse': isVerticalPrice,
      'gap-x-2 items-baseline flex-wrap': !isVerticalPrice,
      'items-center': isPriceCentered
    }"
  >
    <span
      data-testid="productPricing"
      class="product-pricing__price"
      :class="[
        {
          'text-EXPONDO-red': displayDiscount || isImportantPrice,
          'text-EXPONDO-black': !displayDiscount,
          'lg:text-center lg:order-first': !isVerticalPrice
        },
        thinFont ? 'font-normal' : 'font-bold',
        discountedPriceSize
      ]"
    >
      {{ formatPrice(finalPrice) }}
    </span>
    <StrikethroughPrice
      v-if="displayDiscount"
      :class="[{
        'self-end': isVerticalPrice
      }]"
      :size="size"
      :price="formatPrice(fullProductPrice)"
    />
    <div v-if="isActiveProduct && schemaPrice">
      <meta
        :itemprop="SCHEMA_ITEM_PROP.PRICE"
        :content="schemaPrice"
      >
      <meta
        :itemprop="SCHEMA_ITEM_PROP.PRICE_CURRENCY"
        :content="priceCurrency"
      >
    </div>
  </div>
</template>

<script lang="ts">

import type { ProductPricingSize } from '~~/constants/productCardPricing';
import { SCHEMA_ITEM_PROP } from '~~/constants/seo';
import { PRODUCT_PRICING_SIZE } from '~~/constants/productCardPricing';

export default defineComponent({
  name: 'ProductPricing',

  props: {
    fullProductPrice: {
      type: Number,
      required: true,
    },
    discountedPrice: {
      type: Number,
      default: null,
    },
    shouldDisplayDiscount: {
      type: Boolean,
      default: true,
    },
    isActiveProduct: {
      type: Boolean,
      default: false,
    },
    isVerticalPrice: {
      type: Boolean,
      default: false,
    },
    isPriceCentered: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String as PropType<ProductPricingSize>,
      default: PRODUCT_PRICING_SIZE.DEFAULT,
      validator: (value: ProductPricingSize) => {

        return Object.values(PRODUCT_PRICING_SIZE).includes(value);

      },
    },
    isImportantPrice: {
      type: Boolean,
      default: false,
    },
    thinFont: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {

    const { countryLocalization } = useLocalization();
    const { formatCurrency } = useFormatCurrency();
    const priceCurrency = computed(() => (countryLocalization.value.currencyCode || '').toUpperCase());
    const formatPrice = (price: number | null) => {

      if (!price) {

        return '';

      }

      return formatCurrency(price);

    };

    const displayDiscount = computed(() => props.discountedPrice !== null && props.shouldDisplayDiscount);


    const finalPrice = computed(() => {

      const unitPrice = props.discountedPrice ?? props.fullProductPrice;

      return unitPrice;

    });


    const discountedPriceSizes = {
      [PRODUCT_PRICING_SIZE.SMALL]: 'leading-6 text-sm',
      [PRODUCT_PRICING_SIZE.SMALL_PLUS]: 'text-xl',
      [PRODUCT_PRICING_SIZE.MEDIUM]: 'text-2xl',
      [PRODUCT_PRICING_SIZE.DEFAULT]: 'text-3xl',
    };
    const discountedPriceSize = computed(() => discountedPriceSizes[props.size]);

    const schemaPrice = computed(() => {

      const price = finalPrice.value;

      if (price === null || price === undefined) {

        return '';

      }
      const num = Number(price);

      if (Number.isNaN(num)) {

        return '';

      }

      return num.toFixed(2);

    });

    return {
      SCHEMA_ITEM_PROP,
      priceCurrency,
      displayDiscount,
      finalPrice,
      discountedPriceSize,
      formatPrice,
      schemaPrice,
    };

  },
});

</script>
